import { render, staticRenderFns } from "./Ware.vue?vue&type=template&id=f002a45c&"
import script from "./Ware.vue?vue&type=script&lang=js&"
export * from "./Ware.vue?vue&type=script&lang=js&"
import style0 from "./Ware.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports